import api, { METHODS } from './api'
import { ResponseType } from '../common/types/api/request'

export default async function setKeepScreenshotAfterProcessFlag(keepScreenshotAfterProcessFlag: boolean): Promise<ResponseType> {
    const baseErrorMsg = "Error trying to save new value for the flag to keep the screenshot cache after the report's process"
    try {
        const res = await api<ResponseType>(
            `keepScreenshotAfterProcessFlag`, // for apache servers
            METHODS.POST,
            `${keepScreenshotAfterProcessFlag}`
        )

        if (res.error) {
            console.error(baseErrorMsg, res.error)

            return {
                success: false,
                error: res.error
            }
        }

        return res
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error(baseErrorMsg, error)
        
        return {
            success: false,
            error: error
        }
    }
}